// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.CgMoveRight = function CgMoveRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none"},"child":[{"tag":"path","attr":{"d":"M5 17V15H13V17H5Z","fill":"currentColor"}},{"tag":"path","attr":{"d":"M5 9V7H13V9H5Z","fill":"currentColor"}},{"tag":"path","attr":{"d":"M5 12.9999V10.9999H14.9999V7.96454L19.071 11.9644L14.9999 15.9644V12.9999H5Z","fill":"currentColor"}}]})(props);
};
